import { Modal } from '@/components/Modal';

interface DeleteApiKeyModalProps {
  open: boolean;
  apiKey: { key: string; name: string } | null;
  onConfirm: () => void;
  onClose: () => void;
  isPending: boolean;
}

/**
 * DeleteApiKeyModal - Confirmation modal for API key deletion
 *
 * Features:
 * - Displays API key name for confirmation
 * - Disabled state during deletion
 * - Automatic close on success/error (handled by parent)
 *
 * Extracted from ApiKeys.tsx (Lines 168-197)
 * Used in: UserSettingsCards
 */
export function DeleteApiKeyModal({
  open,
  apiKey,
  onConfirm,
  onClose,
  isPending,
}: DeleteApiKeyModalProps) {
  return (
    <Modal
      title="Delete API Key"
      open={open}
      onClose={onClose}
      footer={
        apiKey
          ? {
              text: isPending ? 'Deleting...' : 'Delete',
              styleType: 'primary',
              disabled: isPending,
              onClick: onConfirm,
              'data-testid': 'delete-api-key-confirm-button',
            }
          : undefined
      }
      data-testid="delete-api-key-modal"
    >
      {apiKey && (
        <div>
          Are you sure you want to delete <b>{apiKey.name}</b> API key?
        </div>
      )}
    </Modal>
  );
}
